import Cookies from 'js-cookie';
import { App } from '../../app/App';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { Runtime } from '../Runtime';

export class RuntimePermissions {
  private readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  get runtime(): Runtime {
    return this.parent;
  }

  get solidApp(): App {
    return this.runtime.solidBrowserRuntime.app;
  }

  get hasEditPermissions(): boolean {
    if (this.runtime.isServerRuntime) return true;
    if (!this.solidApp.user) return false;
    if (!this.runtime.availablePackages.Edit) return false;
    return this.solidApp.user.userPermissions.hasEditPermissionsForCurrentLocation;
  }

  get hasAdminPermissions(): boolean {
    if (this.runtime.isServerRuntime) return true;
    if (!this.solidApp.user) return false;
    if (!this.runtime.availablePackages.Edit) return false;
    return this.solidApp.user.userPermissions.hasAdminPermissionsForCurrentLocation;
  }

  @memoize
  get hasEditFunctionality(): boolean {
    if (this.runtime.isServerRuntime) {
      return false;
    }
    if (this.runtime.isBot) return true;
    return !!Cookies.get('edit');
  }

  ensureEditFunctionality() {
    if (!Cookies.get('edit')) {
      Cookies.set('edit', '1', { expires: 365, secure: true });
      if (this.runtime.isBrowserRuntime) {
        window.location.reload();
      }
    }
  }

  get isAutoTextSizingEnabled(): boolean {
    if (!this.runtime.browserRuntime) return false;

    if (this.hasEditFunctionality) {
      return true;
    }

    const { app } = this.runtime.solidBrowserRuntime;
    // if (!app.pathURI.includes('klasse1/deutsch/wörter')) return true;
    if (
      app.question &&
      app.question.questionLayout.layoutBundle &&
      app.question.questionLayout.layoutBundle.local.valueOf.textGrowEnable === 'endUser'
    ) {
      return true;
    }

    return false;
  }
}
